import { authApi } from "api/base";

const getAll = (params) =>
  authApi.get("/banners", {
    params,
  });

const get = (id) => authApi.get(`/banners/${id}`);

const create = ({
    mediaId,
    externalOrInternal,
    url,
    status,
    seq,
  }) =>
  authApi.post(`/banners`, {
    mediaId,
    externalOrInternal,
    url,
    status,
    seq,
  });

const update = ({
  id,
  mediaId,
  externalOrInternal,
  url,
  status,
  seq,
}) =>
  authApi.put(`/banners`, {
    id,
    mediaId,
    externalOrInternal,
    url,
    status,
    seq,
  });

const del = (id) => authApi.delete(`/banners/${id}`);

export {
  getAll,
  get,
  create,
  update,
  del,
};
